import React from "react";
import CaseStudy from "../case/CaseStudy";
import { Section, Figure, Split, Stage, Beat, Grid } from "../case/blocks";
import { useStageParallax, PanGallery } from "../case/motion";
import "../case/case.scss";

import imgRender from "../../../images/addproject/ap-render.png";
import imgDrawing from "../../../images/addproject/ap-drawing.png";
import imgPhoto1 from "../../../images/addproject/ap-photo1.jpg";
import imgPhoto2 from "../../../images/addproject/ap-photo2.jpg";
import imgPhoto3 from "../../../images/addproject/ap-photo3.jpg";
import imgPhoto4 from "../../../images/addproject/ap-photo4.jpg";
import imgPhoto5 from "../../../images/addproject/ap-photo5.jpg";
import imgPhoto6 from "../../../images/addproject/ap-photo6.jpg";
import imgBokeh1 from "../../../images/addproject/ap-bokeh1.jpg";
import imgBokeh2 from "../../../images/addproject/ap-bokeh2.jpg";
import imgBokeh3 from "../../../images/addproject/ap-bokeh3.jpg";

const PRINTS = [
  { src: imgPhoto1, alt: "3D printed speaker housing, front view" },
  { src: imgPhoto2, alt: "3D printed speaker housing, detail of the grille" },
  { src: imgPhoto3, alt: "3D printed speaker parts before assembly" },
  { src: imgPhoto4, alt: "Assembled speaker on the workbench" },
  { src: imgPhoto5, alt: "Speaker housing showing the printed layer texture" },
  { src: imgPhoto6, alt: "Speaker assembly detail" },
];

const AdditionalProject = () => {
  useStageParallax();

  return (
    <CaseStudy
      slug="/additionalproject"
      title="Additional Work"
      tagline="3D printed speaker"
      year="2024"
      roles={["CAD and technical drafting", "3D modeling", "Visualisation"]}
      hero={{ src: imgRender, alt: "Render of the 3D printed speaker" }}
      lead={
        <p>
          The aim of the project was to design a speaker considering the
          functionality as well as manufacturability especially with 3D
          printing.
        </p>
      }
    >
      <Section id="drafting" title="CAD and technical drafting">
        <Split
          media={
            <img
              src={imgDrawing}
              alt="Technical drawing of the speaker housing with dimensions"
            />
          }
          align="center"
        >
          <Beat>
            <p>
              The housing was modelled to print without supports, so the part
              breaks and the wall thicknesses were resolved in CAD rather than
              corrected on the printer.
            </p>
          </Beat>
        </Split>
      </Section>

      <Section
        id="prints"
        title="Printed and assembled"
        lead="Photographs of the printed parts and the assembled speaker."
      >
      </Section>

      <PanGallery label="Printed parts and assembly">
        {PRINTS.map((p) => (
          <img key={p.src} src={p.src} alt={p.alt} />
        ))}
      </PanGallery>

      <Stage
        src={imgBokeh1}
        alt="Speaker photographed against a soft-focus background"
        title="Photography studies"
        height="92dvh"
      />

      <Section id="studies">
        <Grid min={320}>
          <Figure src={imgBokeh2} alt="Speaker lit from the side against bokeh" />
          <Figure src={imgBokeh3} alt="Close detail of the speaker grille against bokeh" />
        </Grid>
      </Section>

      <Stage
        src={imgRender}
        alt="Final render of the 3D printed speaker"
        title="Designed to be printed, not just modelled."
        height="90dvh"
        contain
      />
    </CaseStudy>
  );
};

export default AdditionalProject;
